import { translate } from '../i18n'
import { StringValidator } from './StringValidator'

export class NotEqualsToValidator extends StringValidator {
    current: string | undefined

    constructor(current: string | undefined) {
        super()
        this.current = current
    }

    isValidString(value: string): boolean {
        return this.current !== value
    }

    getMessage = () =>
        translate('validations.not_equals', { current: this.current }) as string
}
